module.exports = "/_next/static/images/1c7a34dd908d143dc53cf81a45b8ae9b-xpeers-mgm-lg.png.webp";